module.exports = __webpack_public_path__ + "static/media/shutterstock_435325255.a458b548.jpg";